import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_DETAILS = 'GET_DETAILS';
export const GET_CHARGE_LINES = 'GET_CHARGE_LINES';

export const actions = createSagaActionTypes('INVOICE_DETAILS', [
  GET_DETAILS,
  GET_CHARGE_LINES
]);
